import React from 'react';
import {observer} from "mobx-react";
import {MenuItemComponentProps} from "../../../../services/menu-items-common/menu-item-component-props.interface";
import {UsefulLinkInnerItemComponent} from './useful-link-inner-item.component';

export const UsefulLinkItemComponent: React.FC<MenuItemComponentProps> = observer((props) => {
    const onClickHandler = async () => {
        await props.menuItem.execute();
    }

    return <UsefulLinkInnerItemComponent onClick={onClickHandler} {...props} />
});